//====================================================
//  Initialization Slider
//====================================================
function fn_parts_checkLayout(){
    if (!$('.side-panel').length) {
    	$('.text-section .full-width').addClass('active');
    }
}